export const THEME_STORAGE_KEY = 'portfolio-theme';

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export function getStoredTheme() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === THEMES.LIGHT || stored === THEMES.DARK) {
      return stored;
    }
  } catch (error) {
    // localStorage may be unavailable (private browsing, blocked, etc.)
  }
  return null;
}

export function getSystemTheme() {
  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return THEMES.DARK;
  }
  return THEMES.LIGHT;
}

export function getInitialTheme() {
  return getStoredTheme() || getSystemTheme();
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);

  const themeColor = theme === THEMES.DARK ? '#121212' : '#ffffff';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', themeColor);
  }
}

export function persistTheme(theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (error) {
    // ignore write failures
  }
}

export function setTheme(theme) {
  applyTheme(theme);
  persistTheme(theme);
}
